import { apiClient } from '@/lib/api'

const BASE_URL = '/v1/arendators'

/**
 * Arendators API Client
 * Handles all API calls for arendators management
 */
export const arendatorsApi = {
  /**
   * Get all arendators with pagination and filters
   */
  getAll: async (params = {}) => {
    const response = await apiClient.get(BASE_URL, { params })
    return response.data
  },

  /**
   * Get arendator by ID
   */
  getById: async (id) => {
    const response = await apiClient.get(`${BASE_URL}/${id}`)
    return response.data
  },

  /**
   * Create new arendator
   */
  create: async (data) => {
    const response = await apiClient.post(BASE_URL, data)
    return response.data
  },

  /**
   * Update arendator (full update)
   */
  update: async (id, data) => {
    const response = await apiClient.put(`${BASE_URL}/${id}`, data)
    return response.data
  },

  /**
   * Partial update arendator
   */
  partialUpdate: async (id, data) => {
    const response = await apiClient.patch(`${BASE_URL}/${id}`, data)
    return response.data
  },

  /**
   * Delete arendator (soft delete)
   */
  delete: async (id) => {
    const response = await apiClient.delete(`${BASE_URL}/${id}`)
    return response.data
  },

  /**
   * Autocomplete search for arendators
   */
  getAutocomplete: async ({ search = '', page = 1, page_size = 20 }) => {
    const params = {
      search,
      page,
      page_size,
    }
    const response = await apiClient.get(BASE_URL, { params })
    return response
  },
}
